import http from './http';

export const getAllSlots = (kb_id, token) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/all-slots', {
    params: {
      kb_id,
      token
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getAllSlotsV2 = (kb_id, token) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/v2/slots/all-slots/v2', {
    params: {
      kb_id,
      token
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getNewTabsSlots = (kb_id) => {
  return http.post(
    import.meta.env.VITE_APP_BASE_API + 'new_bubble/new-tabs-preview',
    {},
    {
      params: { kb_id },
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export const getQuickLinks = (kb_id, slot_id) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/quick-links/' + slot_id,
    {
      params: {
        kb_id
      }
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const createQuickLink = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/quick-links', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const updateQuickLink = (slot_id, data) => {
  return http.patch(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/quick-links/' + slot_id, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const deleteQuickLink = (slot_id, kb_id) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/quick-links/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getMetaLinks = (kb_id, slot_id) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/meta-links/' + slot_id, {
    params: {
      kb_id
    }
  },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

export const createMetaLink = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/meta-links', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const updateMetaLink = (slot_id, data) => {
  return http.patch(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/meta-links/' + slot_id, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const deleteMetaLink = (slot_id, kb_id) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/meta-links/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getLinkGroups = (kb_id, slot_id) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/link-groups/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const createLinkGroup = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/link-groups', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const updateLinkGroup = (slot_id, data) => {
  return http.patch(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/link-groups/' + slot_id, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const deleteLinkGroup = (slot_id, kb_id) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/link-groups/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getVideos = (kb_id, slot_id) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/videos/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const createVideo = (data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/videos', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const updateVideo = (slot_id, data) => {
  return http.patch(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/videos/' + slot_id, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const deleteVideo = (slot_id, kb_id) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/videos/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getTabsPage = (kb_id) => {
  return http.get(import.meta.env.VITE_APP_BASE_API + 'tabs/page', {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const saveTabs = (kb_id, data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/page', data, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const saveSlots = (kb_id, team_id, data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/page', data, {
    params: {
      kb_id,
      team_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
export const saveSlotsV2 = (kb_id, team_id, data) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/v2/page/v2', data, {
    params: {
      kb_id,
      team_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};



export const fetchSlotsByVersion = ({ kb_id, token, useNewVersion }) => {
  return useNewVersion
    ? getAllSlotsV2(kb_id, token)
    : getAllSlots(kb_id, token);
};

export const saveSlotsByVersion = ({ kb_id, team_id, data, useNewVersion }) => {
  return useNewVersion
    ? saveSlotsV2(kb_id, team_id, data)
    : saveSlots(kb_id, team_id, data);
};

export const deleteSlider = (slot_id, kb_id) => {
  return http.delete(import.meta.env.VITE_APP_BASE_API + 'tabs/slots/sliders/' + slot_id, {
    params: {
      kb_id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getMetaData = (link_id) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/metadata', {},
    {
      params: {
        url: link_id
      },
      headers: {
        'Content-Type': 'application/json'
    }
  });
}


export const getThumbnail = (url) => {
  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/video-thumbnail', {}, {
      params: {
        url
      }
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export const uploadVideoToS3 = (kb_id, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return http.post(import.meta.env.VITE_APP_BASE_API + 'tabs/video-to-s3', formData, {
    params: { kb_id },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
